<div class="datatable-filter-popup" [ngStyle]="datatableFilterPosition">
  <div class="datatable-filter-popup__content">
    <form [formGroup]="form" class="row form-wrapper">
      <div class="col-12">
        @if(selectedFilterValues?.length && isMultipleSelectionColumn()) {
          <div class="col-12 filter-title mb-2">{{ 'label.selected_filters' | translate }}</div>
          <div class="table-filters-wrapper">
            @for (value of selectedFilterValues; track $index) {
              <span class="filter-value">{{ value }}<i class="bi bi-x" (click)="removeSelection(value)"></i></span>
            }
          </div>
        }
        <app-input-form-field
          *ngIf="!isMultipleSelectionColumn() && !isBooleanColumn() && !isDateColumn()"
          formControlName="columnSearchValue"
          [label]="'label.search' | translate"
          [placeholder]="'placeholders.search_values'"
          (keydown)="onEnter($event)"
          [translatable]="false"
        ></app-input-form-field>
        <app-input-form-field
          *ngIf="isMultipleSelectionColumn()"
          formControlName="columnSearchValue"
          [label]="'label.search' | translate"
          [placeholder]="'placeholders.search_options'"
          (ngModelChange)="inputSearchUpdate$.next($event)"
          [translatable]="false"
        ></app-input-form-field>
      </div>
      <div class="filter-wrapper" *ngIf="!!filterValues?.length" (scroll)="onScroll($event)">
        <div class="col-12 filter-title mb-2">{{ 'label.filters' | translate }}</div>
        <div class="col-12 mb-2" *ngFor="let item of filterValues">
          <app-checkbox-form-field
            *ngIf="!isBooleanColumn()"
            formControlName="{{item.value}}"
            [label]="item.name | translate"
            [customClass]="'no-text-transformation'"
            (onChangeCheckboxEvent)="addSelection(item.value)"
          ></app-checkbox-form-field>
          <app-checkbox-form-field
            *ngIf="isBooleanColumn()"
            formControlName="{{item.value}}"
            [label]="item.name | translate"
            [customClass]="'no-text-transformation'"
            (onChangeCheckboxEvent)="onChangeCheckbox($event, item.value)"
          ></app-checkbox-form-field>
        </div>
      </div>
      <div class="col-12" *ngIf="isDateColumn()">
        <app-daterangepicker-form-field
          formControlName="dateFilter"
          [label]="'label.select_date' | translate"
          [placeholder]="'placeholders.select_date' | translate"
        ></app-daterangepicker-form-field>
      </div>

      <div class="submit-actions submit-actions-datatable-filter-popup">
        <button class="btn secondary-button" (click)="closeFilter()">{{ 'label.cancel' | translate }}</button>
        <button class="btn primary-button ms-2" (click)="submitForm()">{{ 'buttons.apply' | translate }}</button>
      </div>
    </form>
  </div>
</div>
